<div class="card">

    <!-- Card Header -->
    <div class="card-header">
        <label>{{selectorName}} > Data Summary</label>
        
        <!-- Header actions -->
        <span class="actions">
            <label for="language-select">Language</label>
            <select name="language-select">
                <option>English</option>
            </select>
            <button type="button" class="btn">Export</button>
            <button type="button" class="btn">Home</button>
            <button type="button" class="btn">
                <i class="fa fa-window-maximize"></i>
            </button>
        </span>

    </div>

    <!-- Card Body -->
    <div class="card-body">
        <div class="container">

            <div class="row">

                <div class="col">

                    <!-- Closeout Summary -->
                    <span class="heading" *ngIf="closeOutSummaryVisibility()">
                        <label>Closeout Summary</label>
                    </span>

                    <div class="table-responsive" *ngIf="overAllVisibility()">
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th class="data-summary-th">Overall:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="data-summary-tr" *ngFor="let data of dataSummary.data.overAll">
                                    <td class="data-summary-td">{{ data.name }}</td>
                                    <td class="data-summary-td">{{ data.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" *ngIf="attritionMetricsVisibility()">
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th class="data-summary-th">Attrition Metrics:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="data-summary-tr" *ngFor="let data of dataSummary.data.attritionMetrics">
                                    <td class="data-summary-td">{{ data.name }}</td>
                                    <td class="data-summary-td">{{ data.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="col-2"></div>
            
                <div class="col">
                    <!-- Attrition Economics -->
                    <span class="heading" *ngIf="attritionEconomicsVisibility()">
                        <label>Attrition Economics</label>
                    </span>

                    <div class="table-responsive" *ngIf="fvpMaxMofcAtPrimaryPackerVisibility()">
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th class="data-summary-th">FVP-MAX MOFC at Primary Packer:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="data-summary-tr" *ngFor="let data of dataSummary.data.fvpMaxMofcAtPrimaryPacker">
                                    <td class="data-summary-td">{{ data.name }}</td>
                                    <td class="data-summary-td">{{ data.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" *ngIf="cullsSecondaryMarketVisibility()">
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th class="data-summary-th">Culls - Secondary Market:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="data-summary-tr" *ngFor="let data of dataSummary.data.cullsSecondaryMarket">
                                    <td class="data-summary-td">{{ data.name }}</td>
                                    <td class="data-summary-td">{{ data.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" *ngIf="transportLossesVisibility()">
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th class="data-summary-th">Transport Losses:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="data-summary-tr" *ngFor="let data of dataSummary.data.transportLosses">
                                    <td class="data-summary-td">{{ data.name }}</td>
                                    <td class="data-summary-td">{{ data.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>